import { contentCartSelector } from '../constants';

export const isContentCart = (): boolean => {
  return !!document.querySelector(contentCartSelector);
};
